import React from 'react';
import PropTypes from 'prop-types';

import { Translate, SafeAnchor } from '@hydra/common/components';
import { Criterium, CriteriumSkeleton, CriteriumTable } from '@hydra/common/criterium';
import { useReviewContext } from '@hydra/common/context';

export const Images = ({ criterium }) => {
  const { data, url } = criterium;

  const count = data.length;
  const withoutAlt = data.filter(image => !image.hasAlt);
  const countWithoutAlt = withoutAlt.length;
  const { variant } = useReviewContext();
  const teaser = withoutAlt
    .map(({ src }) => ([
      <SafeAnchor rel='nofollow noopener noreferrer' title={src} target='_blank' href={src} key={src}>
        {src}
      </SafeAnchor>
    ]));

  const content = count > 0
    ? (
      <>
        {variant === 'nocrit' ? <CriteriumSkeleton width='70%' /> : <Translate component='p' content='images_found' with={{ count }} />}
        {
          countWithoutAlt > 0
            ? (
              <>
                {variant === 'nocrit' ? <CriteriumSkeleton width='60%' /> : <Translate component='p' content='missing_alts' with={{ count: countWithoutAlt }} />}
                <CriteriumTable
                  rows={teaser}
                  striped
                  thinHead
                  nowrap
                />
              </>
              )
            : (variant === 'nocrit' ? <CriteriumSkeleton width='70%' /> : <Translate content='no_missing_alts' />)
        }
      </>
      )
    : variant === 'nocrit' ? <CriteriumSkeleton width='70%' /> : <Translate content='no_images_found' />;
  return (
    <Criterium
      criterium={criterium}
      variables={{ domain: url, noAltCount: countWithoutAlt.toString() }}
    >
      {content}
    </Criterium>
  );
};

Images.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.array
  })
};

export default React.memo(Images);
